import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class TrainingService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation TRAINING_UPDATE(
          $id: String!
          $data: TrainingInput!
        ) {
          trainingUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.trainingUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation TRAINING_DESTROY($ids: [String!]!) {
          trainingDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.trainingDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation TRAINING_CREATE($data: TrainingInput!) {
          trainingCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.trainingCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation TRAINING_IMPORT(
          $data: TrainingInput!
          $importHash: String!
        ) {
          trainingImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.trainingImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query TRAINING_FIND($id: String!) {
          trainingFind(id: $id) {
            id
            title
            description
            date
            hour
            duration
            location
            status
            team {
              id
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.trainingFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query TRAINING_LIST(
          $filter: TrainingFilterInput
          $orderBy: TrainingOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          trainingList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              title
              description
              date
              hour
              duration
              location
              status
              team {
                id
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.trainingList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query TRAINING_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          trainingAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.trainingAutocomplete;
  }
}
